<div *ngIf="show" class="contentLoaderGlobal">
    <div>
        <!-- <fa-icon icon="spinner" [spin]="true"></fa-icon> -->
        <img src="./assets/img/Simbolodeespera1.gif" alt="" style="width: 200px;">
    </div>
</div>

